import classNames from 'classnames';

type Props = {
  brand: 'facebook' | 'twitter' | 'youtube' | 'instagram' | 'mail' | string;
  disabled?: boolean;
  hasBrandColor?: boolean;
  onClick?: () => void;
};
export default function SocialButton({ brand, hasBrandColor = true, onClick = () => {}, disabled = false }: Props) {
  const classes = classNames({
    'social-button': true,
    [`social-button__${brand}`]: hasBrandColor,
    'social-button--no-brand-color': !hasBrandColor,
    'social-button--disabled': disabled,
  });
  return (
    <button
      aria-label={brand}
      className={classes}
      title={brand}
      type="button"
      onClick={onClick}
    >
      <span className={`icon icon-${brand}`} />
    </button>
  );
}
